import React, { useState, useEffect, useCallback } from 'react'
import assetsImage1 from '/img/alexandra-tran-fS3tGOkp0xY-unsplash.jpg'
import assetsImage2 from '/img/anastase-maragos-7kEpUPB8vNk-unsplash.jpg'
import assetsImage3 from '/img/content-pixie-be-6rpnQ30k-unsplash.jpg'
import assetsImage4 from '/img/protein.jpg'
import assetsImage5 from '/img/clothes-workout-kit-sport-ba.webp'
import { entityToSpanish } from '@/utils/entity-convert'
import { Entities } from '@/entities/api/entities'
import { Link } from 'react-router-dom'

interface SlideData {
	id: number
	title: string
	subtitle: string
	ctaText: string
	ctaSecondary?: string
	backgroundImage: string
	category: 'supplements' | 'clothing' | 'training' | 'accessories'
	to: string
	badge?: string
	stats?: {
		metric: string
		value: string
	}[]
}

const slidesData: SlideData[] = [
	{
		id: 0,
		title: 'PROMOCIONES EXCLUSIVAS',
		subtitle:
			'Bienvenido a SportCenter Shop, tu tienda fitness y gimnasio de confianza. Aprovecha nuestras ofertas especiales en suplementos, ropa y accesorios.',
		ctaText: 'DESCUBRIR PROMOCIONES',
		ctaSecondary: 'Ver Todo',
		to: '/Promociones',
		backgroundImage: assetsImage1,
		category: 'supplements',
		badge: '🔥 HASTA 50% OFF',
		stats: [
			{ metric: 'Usuarios Activos', value: '1000+' },
			{ metric: 'Años en el Mercado', value: '2' },
		],
	},
	{
		id: 1,
		title: 'SUPLEMENTOS PARA TU RENDIMIENTO',
		subtitle:
			'Explora nuestra línea de suplementos seleccionados para mejorar tu fuerza, energía y recuperación. Fórmulas confiables, resultados visibles.',
		ctaText: 'VER SUPLEMENTOS',
		ctaSecondary: 'Catálogo Completo',
		to: `/Categoria/${entityToSpanish(Entities.SUPPLEMENTS)}`,
		backgroundImage: assetsImage4,
		category: 'supplements',
		badge: '🏋️ PROTEÍNAS PREMIUM',
		stats: [
			{ metric: 'Clientes Satisfechos', value: '5K+' },
			{ metric: 'Recomendado', value: 'Top 1' },
		],
	},
	// {
	// 	id: 2,
	// 	title: 'VISTE TU ENTRENAMIENTO',
	// 	subtitle:
	// 		'Ropa deportiva funcional, ligera y cómoda para cada sesión. Diseños modernos pensados para maximizar tu rendimiento.',
	// 	ctaText: 'IR A ROPA',
	// 	ctaSecondary: 'Explorar Nuevos',
	// 	to: `/Categoria/${entityToSpanish(Entities.CLOTHES)}`,
	// 	backgroundImage: assetsImage5,
	// 	category: 'clothing',
	// 	badge: '👕 NUEVA COLECCIÓN',
	// 	stats: [
	// 		{ metric: 'Descuento', value: '30%' },
	// 		{ metric: 'Stock Disponible', value: '200+' },
	// 	],
	// },
	{
		id: 3,
		title: 'PLANES ENTRENAMIENTO Y NUTRICIÓN',
		subtitle:
			'Comienza tu transformación con planes adaptados a tus metas. Nuestro equipo te acompaña con asesorías personalizadas.',
		ctaText: 'EMPEZAR PLAN',
		ctaSecondary: 'Agendar Consulta',
		to: `/Categoria/${entityToSpanish(Entities.PLANS_PERSONALIZED)}`,
		backgroundImage: assetsImage2,
		category: 'training',
		badge: '🎯 PLANES PERSONALIZADOS',
		stats: [
			{ metric: 'Satisfacción', value: '95%' },
			{ metric: 'Soporte', value: '24/7' },
		],
	},
	// {
	// 	id: 4,
	// 	title: 'ACCESORIOS PARA TU RUTINA',
	// 	subtitle:
	// 		'Completa tu entrenamiento con los mejores accesorios fitness: ligas, mancuernas, mats, bandas y más.',
	// 	ctaText: 'COMPRAR ACCESORIOS',
	// 	ctaSecondary: 'Ver Ofertas',
	// 	to: `/Categoria/${entityToSpanish(Entities.ACCESSORIES)}`,
	// 	backgroundImage: assetsImage3,
	// 	category: 'accessories',
	// 	badge: '🏠 GIMNASIO EN CASA',
	// 	stats: [
	// 		{ metric: 'Durabilidad', value: 'Alta' },
	// 		{ metric: 'Garantía', value: '2 años' },
	// 	],
	// },
]

const Carousel: React.FC = () => {
	const [currentSlide, setCurrentSlide] = useState<number>(0)
	const [isAutoPlaying, setIsAutoPlaying] = useState<boolean>(true)
	const [imageLoaded, setImageLoaded] = useState<Record<number, boolean>>({})
	const [touchStart, setTouchStart] = useState<number>(0)
	const [touchEnd, setTouchEnd] = useState<number>(0)

	const goToSlide = useCallback((index: number): void => {
		setCurrentSlide(index)
	}, [])

	const nextSlide = useCallback((): void => {
		setCurrentSlide((prev) => (prev + 1) % slidesData.length)
	}, [])

	const prevSlide = useCallback((): void => {
		setCurrentSlide(
			(prev) => (prev - 1 + slidesData.length) % slidesData.length
		)
	}, [])

	useEffect(() => {
		if (!isAutoPlaying) return

		const interval = setInterval(() => {
			nextSlide()
		}, 5000)

		return () => clearInterval(interval)
	}, [isAutoPlaying, nextSlide])

	const handleMouseEnter = (): void => setIsAutoPlaying(false)
	const handleMouseLeave = (): void => setIsAutoPlaying(true)

	const handleTouchStart = (e: React.TouchEvent): void => {
		setTouchStart(e.targetTouches[0].clientX)
	}

	const handleTouchMove = (e: React.TouchEvent): void => {
		setTouchEnd(e.targetTouches[0].clientX)
	}

	const handleTouchEnd = (): void => {
		if (!touchStart || !touchEnd) return

		const distance = touchStart - touchEnd
		const isLeftSwipe = distance > 50
		const isRightSwipe = distance < -50

		if (isLeftSwipe) {
			nextSlide()
		} else if (isRightSwipe) {
			prevSlide()
		}

		setTouchStart(0)
		setTouchEnd(0)
	}

	useEffect(() => {
		const handleKeyPress = (e: KeyboardEvent): void => {
			if (e.key === 'ArrowLeft') prevSlide()
			if (e.key === 'ArrowRight') nextSlide()
		}

		window.addEventListener('keydown', handleKeyPress)
		return () => window.removeEventListener('keydown', handleKeyPress)
	}, [nextSlide, prevSlide])

	useEffect(() => {
		slidesData.forEach((slide) => {
			const img = new Image()
			img.onload = () => {
				setImageLoaded((prev) => ({ ...prev, [slide.id]: true }))
			}
			img.src = slide.backgroundImage
		})
	}, [])

	return (
		<div className='w-full p-1 sm:p-2 lg:p-0 rounded-lg overflow-hidden h-[60vh] sm:h-[55vh] md:h-auto'>
			<div
				className='relative w-full h-full rounded-lg overflow-hidden shadow-2xl bg-gray-900'
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				onTouchStart={handleTouchStart}
				onTouchMove={handleTouchMove}
				onTouchEnd={handleTouchEnd}
			>
				<div className='relative w-full h-full'>
					{slidesData.map((slide, index) => (
						<div
							key={slide.id}
							className={`absolute inset-0 transition-all duration-1000 ease-in-out transform ${
								index === currentSlide
									? 'opacity-100 scale-100 z-10'
									: index ===
									  (currentSlide - 1 + slidesData.length) % slidesData.length
									? 'opacity-0 scale-105 z-0 -translate-x-full'
									: index === (currentSlide + 1) % slidesData.length
									? 'opacity-0 scale-105 z-0 translate-x-full'
									: 'opacity-0 scale-110 z-0'
							}`}
						>
							<div
								className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-[8000ms] ease-out ${
									index === currentSlide ? 'scale-110' : 'scale-100'
								} ${!imageLoaded[slide.id] ? 'bg-gray-800' : ''}`}
								style={{
									backgroundImage: `url(${slide.backgroundImage})`,
								}}
							>
								{!imageLoaded[slide.id] && (
									<div className='absolute inset-0 bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800 animate-pulse' />
								)}
							</div>

							<div className='absolute inset-0 bg-black bg-opacity-50' />
							<div className='absolute inset-0 bg-gradient-to-r from-black via-transparent to-transparent opacity-70' />

							<div className='relative z-20 h-full flex items-center'>
								<div className='w-full px-6 md:px-12 lg:px-16'>
									<div
										className={`max-w-2xl transition-all duration-1000 ease-out ${
											index === currentSlide
												? 'opacity-100 translate-y-0'
												: 'opacity-0 translate-y-8'
										}`}
										style={{
											transitionDelay: index === currentSlide ? '300ms' : '0ms',
										}}
									>
										{slide.badge && (
											<div className='inline-flex items-center px-4 py-2 bg-red-600 text-white text-xs md:text-sm font-bold rounded-full mb-4 md:mb-6 animate-pulse'>
												{slide.badge}
											</div>
										)}

										<h1 className='text-3xl md:text-5xl lg:text-6xl font-black text-white mb-3 md:mb-4 leading-tight tracking-tight'>
											{slide.title}
										</h1>

										<p className='text-sm md:text-lg text-gray-200 mb-6 md:mb-8 leading-relaxed max-w-xl'>
											{slide.subtitle}
										</p>

										{slide.stats && (
											<div className='flex space-x-6 mb-6 md:mb-8'>
												{slide.stats.map((stat, statIndex) => (
													<div
														key={statIndex}
														className={`text-center transition-all duration-700 ease-out ${
															index === currentSlide
																? 'opacity-100 translate-y-0'
																: 'opacity-0 translate-y-4'
														}`}
														style={{
															transitionDelay:
																index === currentSlide
																	? `${600 + statIndex * 100}ms`
																	: '0ms',
														}}
													>
														<div className='text-xl md:text-2xl font-bold text-white'>
															{stat.value}
														</div>
														<div className='text-xs md:text-sm text-gray-300'>
															{stat.metric}
														</div>
													</div>
												))}
											</div>
										)}

										<div
											className={`flex flex-col sm:flex-row gap-3 md:gap-4 transition-all duration-700 ease-out ${
												index === currentSlide
													? 'opacity-100 translate-y-0'
													: 'opacity-0 translate-y-4'
											}`}
											style={{
												transitionDelay:
													index === currentSlide ? '800ms' : '0ms',
											}}
										>
											<Link
												to={slide.to}
												className='bg-red-600 hover:bg-red-700 text-white font-bold py-3 md:py-4 px-6 md:px-8 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl text-sm md:text-lg shadow-lg relative overflow-hidden group'
											>
												<span className='relative z-10'>{slide.ctaText}</span>
												<div className='absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-all duration-700'></div>
											</Link>
										</div>
									</div>
								</div>
							</div>

							<div className='absolute top-4 right-4 bg-white bg-opacity-10 backdrop-blur-sm text-white px-3 py-1 rounded-full text-xs font-bold'>
								SPORTCENTER
							</div>
						</div>
					))}
				</div>

				<button
					onClick={prevSlide}
					className='absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-3 rounded-full transition-all duration-200 backdrop-blur-sm z-30 group hover:scale-110'
					aria-label='Slide anterior'
				>
					<svg
						className='w-6 h-6 transition-transform group-hover:-translate-x-1'
						fill='none'
						stroke='currentColor'
						viewBox='0 0 24 24'
					>
						<path
							strokeLinecap='round'
							strokeLinejoin='round'
							strokeWidth={2}
							d='M15 19l-7-7 7-7'
						/>
					</svg>
				</button>

				<button
					onClick={nextSlide}
					className='absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-3 rounded-full transition-all duration-200 backdrop-blur-sm z-30 group hover:scale-110'
					aria-label='Siguiente slide'
				>
					<svg
						className='w-6 h-6 transition-transform group-hover:translate-x-1'
						fill='none'
						stroke='currentColor'
						viewBox='0 0 24 24'
					>
						<path
							strokeLinecap='round'
							strokeLinejoin='round'
							strokeWidth={2}
							d='M9 5l7 7-7 7'
						/>
					</svg>
				</button>

				<div className='absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-3 z-30'>
					{slidesData.map((_, index) => (
						<button
							key={index}
							onClick={() => goToSlide(index)}
							className={`transition-all duration-300 rounded-full ${
								index === currentSlide
									? 'w-8 h-3 bg-red-600 shadow-lg shadow-red-600/50'
									: 'w-3 h-3 bg-white bg-opacity-50 hover:bg-opacity-75 hover:scale-125'
							}`}
							aria-label={`Ir a slide ${index + 1}`}
						/>
					))}
				</div>

				<div className='absolute bottom-0 left-0 w-full h-1 bg-black bg-opacity-30 z-30'>
					<div
						className='h-full bg-red-600 transition-all duration-300 ease-out'
						style={{
							width: `${((currentSlide + 1) / slidesData.length) * 100}%`,
						}}
					/>
				</div>

				{isAutoPlaying && (
					<div className='absolute top-4 left-4 bg-green-500 bg-opacity-80 text-white px-2 py-1 rounded-full text-xs font-bold z-30 animate-pulse'>
						⏯ AUTO
					</div>
				)}
			</div>
		</div>
	)
}

export default Carousel
